import { css } from "@emotion/css";

export const iconStyles = css({
    width: "1em",
    height: "1em",
    fill: "currentcolor",
    display: "inline-block",
});
